//import ReactGA from 'react-ga';
import { isMobile } from '../webscan/utils/device';
import { gtag, install } from 'ga-gtag';
import {GetWidgetConfig} from './SizerAppAPI';

//var APP_GA_ID       = 'UA-209501770-1';   // old ID for react-ga
var APP_GA_ID       = 'G-ZP0318F9ZN';       // new ID for ga-gtag

//var APP_GA_CATEGORY = 'Mobile App WebView'; // old category for react-ga
const APP_GA_MOBLIE = "webscan mobile";
const APP_GA_DESKTOP = "webscan desktop";

export const SizerAppGA = {
    initializeGA,
    reportActivity,
    setUserID,
    reportScreenView,
    reportUserHeight
};

export function initializeGA()
{
//    let url = window.location.href;//window.location.pathname + window.location.search;
    install(APP_GA_ID);
}

export function setUserID(userid)
{
    gtag('set', 'user_id', userid);
}
    
function getURLforReporting(screenid)
{
    let curURL = window.location.href + '/'+screenid;
    return curURL;
}

// call on every event that is not page change (e.g. clicked on a button)
export function reportActivity(pageState,action='',recommendedSize='')
{
    if (isMobile){
        let widgetConfig = GetWidgetConfig();
        gtag('event', 'webscan', {
            'scan_stage': pageState, 
            'scan_action': action,
            'partner_id': widgetConfig.clientid,
            'partner_name': widgetConfig.clientid,
            'product_name': '',
            'product_id': '',
            });
        if (recommendedSize){
            gtag('event', 'webscan', {
                'scan_stage': pageState, 
                'scan_action': action,
                'recommended_size': recommendedSize,
                'partner_id': widgetConfig.clientid,
                'partner_name': widgetConfig.clientid,
                'product_name': '',
                'product_id': '',
                }); 
        }
    }
}

// call on every screen change with UNIQUE URL per screen
export function reportScreenView(screenid, subscreenid='')
{
    let widgetConfig = GetWidgetConfig();
    let screenid_to_report = screenid;
    if (subscreenid!=='')
        screenid_to_report += '/'+subscreenid;
    let data = {
        'page_title': screenid_to_report, 
        'page_path': getURLforReporting(screenid_to_report),
        'partner_id': widgetConfig.clientid,
        'partner_name': widgetConfig.clientid,
        'product_name': '',
        'product_id': '',
    }
    gtag('event', 'page_view', data);   
}

export function reportUserHeight(height, units){
    let userHeightStr = 'user_height_' + height + '_' + units
    gtag('event', userHeightStr, {
        'height': height.toString(), 
        'unit': units});
}
